import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Container from "./core/Container";
import Image from "./core/Image";
import Link from "./core/Link";
import Button from "./core/Button";

export default function Nav(){
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const scrollToContact = () => {
        setIsMenuOpen(false);
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
                const element = document.getElementById("kontaktujte_nas");
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        } else {
            const element = document.getElementById("kontaktujte_nas");
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    const scrollToSubscribeUs = () => {
        setIsMenuOpen(false);
        if (location.pathname !== "/") {
            navigate("/");
            setTimeout(() => {
                const element = document.getElementById("odber_newsletteru");
                if (element) {
                    element.scrollIntoView({ behavior: "smooth", block: "start" });
                }
            }, 100);
        } else {
            const element = document.getElementById("odber_newsletteru");
            if (element) {
                element.scrollIntoView({ behavior: "smooth", block: "start" });
            }
        }
    };

    return(
        <Container shadow={true} radius="md" className="w-full p-2 border-b-2 overflow-x-hidden relative z-20">
            <Container className="max-w-7xl mx-auto flex justify-between items-center px-4">
                <Container className="flex items-center">
                    <Link to="/" >
                        <Image  
                            id="nav_logo"
                            width={85} 
                            height={85} 
                            src="logo500x500_transparent.png"
                            alt="digibezstresu Logo"
                        />
                    </Link>
                </Container>
                
                {/* Desktop Menu */}
                <Container className="hidden md:flex justify-end items-center gap-4">
                    <Link to="/" variant="nav">O nás</Link>
                    <Link to="/kurzy" variant="nav">Kurzy</Link>
                    <button
                        type="button"
                        onClick={scrollToSubscribeUs}
                        className="text-gray-700 hover:text-gray-900 transition-colors px-3 py-2 rounded-md hover:bg-gray-100"
                    >
                        Odběr newsletteru
                    </button>
                    <button onClick={scrollToContact} className="text-white px-3 py-2 rounded-md bg-second_light hover:text-blue-800 hover:bg-gray-100 transition-colors">
                        Kontaktujte nás
                    </button>
                </Container>

                {/* Hamburger Button */}
                <Button
                    onClick={toggleMenu}
                    variant="ghost"
                    className="md:hidden p-2 flex flex-col gap-1.5"
                    aria-label="Toggle menu"
                >
                    <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${isMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
                    <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${isMenuOpen ? 'opacity-0' : ''}`}></span>
                    <span className={`block w-6 h-0.5 bg-current transition-all duration-300 ${isMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
                </Button>
            </Container>

            {/* Mobile Menu */}
            {isMenuOpen && (
                <Container className="md:hidden border-t border-gray-200 mt-2">
                    <Container className="flex flex-col gap-4 px-4 py-4">
                        <Link to="/" variant="nav" onClick={() => setIsMenuOpen(false)}>O nás</Link>
                        <Link to="/kurzy" variant="nav" onClick={() => setIsMenuOpen(false)}>Kurzy</Link>
                        <button
                            type="button"
                            onClick={scrollToSubscribeUs}
                            className="text-gray-700 hover:text-gray-900 transition-colors px-3 py-2 rounded-md hover:bg-gray-100 text-left"
                        >
                            Odběr newsletteru
                        </button>
                        <button onClick={scrollToContact} className="text-white px-3 py-2 rounded-md bg-second_light hover:text-blue-800 hover:bg-gray-100 transition-colors text-left">
                            Kontaktujte nás
                        </button>
                    </Container>
                </Container>
            )}
        </Container>
    )
}